import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { GeneralAdminRoutes } from "../../../../../constants";

const GAClassroomAudioReactionsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  columnWidths,
}) => {
  const navigate = useNavigate();

  const handleNavigateToDetails = () => {
    navigate(GeneralAdminRoutes.classroomAudioReactionDetails.replace(":id", row.id), {
      state: { classroomAudioReaction: row },
    });
  };

  const hasProcessedAudio = !!row?.processedAudioUrl;

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 48,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => handleClickRow(event, row.id)}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{
            "aria-labelledby": labelId,
          }}
        />
      </TableCell>

      {/* Class Name */}
      <TableCell
        id={labelId}
        align="left"
        scope="row"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.className || 180,
          minWidth: columnWidths?.className || 120,
          maxWidth: columnWidths?.className || 260,
        }}
        title={row?.className}
      >
        {row?.className || ""}
      </TableCell>

      {/* Activity Name */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.activityName || 180,
          minWidth: columnWidths?.activityName || 120,
          maxWidth: columnWidths?.activityName || 260,
        }}
        title={row?.activityName}
      >
        {row?.activityName || ""}
      </TableCell>

      {/* Reaction To */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.reactionTo || 120,
          minWidth: columnWidths?.reactionTo || 90,
          maxWidth: columnWidths?.reactionTo || 160,
        }}
      >
        {row?.reactionTo || ""}
      </TableCell>

      {/* QuickTale Title */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.quicktaleTitle || 180,
          minWidth: columnWidths?.quicktaleTitle || 120,
          maxWidth: columnWidths?.quicktaleTitle || 260,
        }}
        title={row?.quicktaleTitle}
      >
        {row?.quicktaleTitle || ""}
      </TableCell>

      {/* Create Date */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 120,
          maxWidth: columnWidths?.createdAt || 220,
        }}
      >
        {row?.createdAt?.seconds
          ? moment.unix(row.createdAt.seconds).format("MM-DD-YYYY HH:mm:ss")
          : ""}
      </TableCell>

      {/* Submitted By */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.submittedBy || 160,
          minWidth: columnWidths?.submittedBy || 120,
          maxWidth: columnWidths?.submittedBy || 240,
        }}
        title={row?.submittedBy}
      >
        {row?.submittedBy || ""}
      </TableCell>

      {/* Processed Audio */}
      <TableCell
        align="center"
        style={{
          border: "1px solid #BABABA",
          width: columnWidths?.processedAudioUrl || 120,
          minWidth: columnWidths?.processedAudioUrl || 100,
          maxWidth: columnWidths?.processedAudioUrl || 180,
        }}
        onClick={handleNavigateToDetails}
      >
        {hasProcessedAudio ? (
          <PlayCircleFilledWhiteOutlinedIcon
            fontSize="large"
            style={{ color: "#00A7CD" }}
          />
        ) : (
          <CancelIcon fontSize="large" style={{ color: "#D32F2F" }} />
        )}
      </TableCell>

      {/* Length */}
      <TableCell
        align="right"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.audioLength || 100,
          minWidth: columnWidths?.audioLength || 80,
          maxWidth: columnWidths?.audioLength || 140,
          paddingRight: 12,
        }}
      >
        {row?.audioLength != null ? row.audioLength : ""}
      </TableCell>

      {/* Reaction ID */}
      <TableCell
        align="left"
        onClick={handleNavigateToDetails}
        style={{
          ...tableCellStyles,
          width: columnWidths?.id || 260,
          minWidth: columnWidths?.id || 200,
          maxWidth: columnWidths?.id || 420,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={row?.id}
      >
        {row?.id}
      </TableCell>
    </TableRow>
  );
};

export default GAClassroomAudioReactionsTableRow;

const tableCellStyles = {
  paddingLeft: 10,
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
